module.exports = __webpack_public_path__ + "static/media/NFCC-logo_KO.02186006.svg";